import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { useNavigate, Link } from "react-router-dom";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TextField,
  InputAdornment,
  TablePagination,
  Divider,
} from "@mui/material";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { IconFileDownload, IconPlus, IconSearch } from "@tabler/icons";
import PageContainer from "src/components/container/PageContainer";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import ParentCard from "src/components/shared/ParentCard";
import WheelTypeService from "src/service/wheel";
import swal from "sweetalert";
import { writeFile } from "xlsx";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Vehicle Wheel ",
  },
];

const Wheel = () => {
  const navigate = useNavigate();

  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [wheels, setWheels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [visibleData, setVisibleData] = useState([]);

  const fetchWheelsData = async () => {
    try {
      const res = await WheelTypeService.getWheelType({});
      setWheels(res.data);
      setVisibleData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteWheelType = async (id) => {
    swal({
      title: "Delete wheel",
      text: "Are you sure you want to delete this wheel?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await WheelTypeService.deleteWheelType({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");
            fetchWheelsData();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  useEffect(() => {
    fetchWheelsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const filteredWheels = wheels.filter((man) =>
    man.wheel_type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const filteredData = wheels.filter((man) =>
      man.wheel_type.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const visibleData = filteredData.slice(startIndex, endIndex);
    setVisibleData(visibleData);
  }, [wheels, page, rowsPerPage, searchTerm]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExport = () => {
    const headers = ["Sl. No", "Vehicle Wheel"];

    const data = visibleData.map((man, index) => [index + 1, man.wheel_type]);

    const exportData = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    const fileName = "exported_data.xlsx";

    writeFile(wb, fileName);
  };

  return (
    <PageContainer title="Vehicle Wheel" description="this is Basic Table page">
      <Breadcrumb title="Vehicle Wheel" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Vehicle Wheel List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            {sessionData.data.user_type === 1 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/addWheelType");
                }}
              >
                <IconPlus width={20} />
              </Button>
            )}
            <Button variant="contained" color="success" onClick={handleExport}>
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "20px;",
              marginTop: "20px;",
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconSearch size="1.1rem" />
                  </InputAdornment>
                ),
              }}
              placeholder="Search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        </Grid>

        <Paper variant="outlined">
          <TableContainer>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "#895c5c33" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "15px", textAlign: "center" }}
                      variant="h6"
                    >
                      No of Wheels
                    </Typography>
                  </TableCell>
                  {sessionData.data.user_type === 1 && (
                    <TableCell>
                      <Typography
                        style={{ fontSize: "15px", textAlign: "center" }}
                        variant="h6"
                      >
                        Action
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredWheels.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} style={{ textAlign: "center" }}>
                      <Typography
                        style={{ fontSize: "13px" }}
                        variant="h6"
                        sx={{ color: "red" }}
                      >
                        No records found!!
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredWheels
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((man, index) => (
                      <TableRow key={man.id}>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {index + 1}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontSize: "13px", textAlign: "center" }}
                            variant="h6"
                          >
                            {man.wheel_type}
                          </Typography>
                        </TableCell>
                        {sessionData.data.user_type === 1 && (
                          <TableCell
                            style={{ fontSize: "13px", textAlign: "center" }}
                          >
                            <Link to={`/updateWheel/${man.id}`}>
                              <ModeEditOutlinedIcon
                                style={{
                                  color: "blue",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>

                            <DeleteOutlinedIcon
                              style={{
                                color: "red",
                                fontSize: "18px",
                                marginLeft: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteWheelType(man.id)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          component="div"
          count={filteredWheels.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </ParentCard>
    </PageContainer>
  );
};

export default Wheel;
